export default __webpack_public_path__ + "media/images/fonts/fontawesome-webfont-32400f4e08932a94d8bfd2422702c446.eot";